<div [dir]="this.app.getUserDire()">
    <div class="d-flex justify-content-between p-2">
        <div></div>
        <p class="interP m-0">{{ 'social.Interests' | translate }}</p>
        <mat-icon (click)="cancel()" class="xIcon material-symbols-outlined pointer">cancel</mat-icon>
    </div>
    
    <hr>
    
    <div class="p-3">
        <p>{{ 'social.pleaseSelectGroups' | translate }}</p>
    
        <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{ 'social.search' | translate }}</mat-label>
            <input  (ngModelChange)="onInputChange()" type="text" [formControl]="searchControl" matInput>
        </mat-form-field>
    
        <!-- chips selected -->
        <div class="mb-3">
            <mat-chip-list #chipGrid aria-label="Fruit selection">
                <!-- (removed)="removeChip(obj)" -->
                <mat-chip *ngFor="let obj of selectedChips">
                    {{obj?.name}}
                    <!-- <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button> -->
                </mat-chip>
            </mat-chip-list>
    
        </div>
        <!-- chips selected -->
    
    
        <!-- check boxes -->
        <div class="px-3">
    
            <section class="example-section">
                <div *ngFor="let item of ObjFiltered">
                    <p class="centerXY px-2 m-0"><span>{{item?.name}}</span><mat-checkbox [value]="item?.id"
                            (change)="onChangeSelection($event,item)"></mat-checkbox></p>
                    <hr>
                </div>
            </section>
    
        </div>
        <!-- check boxes -->
    
        <div class="mt-4 d-flex justify-content-center">
            <button [disabled]="this?.selectedChips?.length == 0" (click)="submit()" class="btn bgMain w-70">{{ 'social.next' | translate }}</button>
        </div>
    
    </div>
</div>